import { Checkbox } from '@headlessui/react';

import CheckIcon from '~/shared/assets/icons/check.svg';
import Typography from '~/shared/components/Typography';

const autoscaleStateOptions: Array<{ id: string; label: string }> = [
  { id: 'as_state_on', label: 'Active' },
  { id: 'as_state_off', label: 'Inactive' },
];

export default function AutoScalingStateFilter({
  pendingAutoscaleState,
  setPendingAutoscaleState,
}: {
  pendingAutoscaleState: string[];
  setPendingAutoscaleState: (states: string[]) => void;
}) {
  const handleStateChange = (optionId: string) => {
    if (pendingAutoscaleState.includes(optionId)) {
      setPendingAutoscaleState(pendingAutoscaleState.filter((s) => s !== optionId));
    } else {
      setPendingAutoscaleState([...pendingAutoscaleState, optionId]);
    }
  };

  return (
    <div className="px-8 py-3 border-y border-gray-300">
      <Typography fontWeight={600} variant="p2-semi" color="font-family-outfit text-primary-900 ">
        Autoscaling
      </Typography>
      <div className="flex gap-6 mt-3 py-2.5 ">
        {autoscaleStateOptions.map((option) => {
          const id = `autoscale-option-${option.id}`;
          return (
            <div key={option.id} className="flex items-center gap-2">
              <Checkbox
                id={id}
                checked={pendingAutoscaleState.includes(option.id)}
                onChange={() => handleStateChange(option.id)}
                className="group block size-5 p-[4px] rounded border border-primary-100 bg-white data-checked:bg-primary-500 ring:0 active:ring-primary-300 focus:ring-primary-500 cursor-pointer"
              >
                <CheckIcon className="text-white stroke-2 size-2.5 opacity-0 group-data-checked:opacity-100 transition duration-200 ease-in-out" />
              </Checkbox>
              <label
                htmlFor={id}
                className="cursor-pointer"
                onClick={() => handleStateChange(option.id)}
              >
                <Typography variant="p2-semi">{option.label}</Typography>
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
